import { gql } from 'apollo-angular';

import {
  SNK_PRICE_DESCRIPTOR_CHANGED_FRAGMENT, SNK_PRICE_DESCRIPTOR_FRAGMENT
} from 'graphql/fragments/snk-price-descriptor';

export const PRODUCT_LINE_PRICING_FRAGMENT = gql`
  fragment ProductLinePricingFragment on ProductLine {
    pricing {
      listPrice { ...SnkPriceDescriptorFragment }
      basePrice { ...SnkPriceDescriptorFragment }
      totalBasePrice { ...SnkPriceDescriptorFragment }
      totalSellPrice { ...SnkPriceDescriptorFragment }
      totalLpAndTzPlusBOM { ...SnkPriceDescriptorFragment }

      elements {
        name

        listPrice { ...SnkPriceDescriptorFragment }
        basePrice { ...SnkPriceDescriptorFragment }
        totalBasePrice { ...SnkPriceDescriptorFragment }
        totalSellPrice { ...SnkPriceDescriptorFragment }
        tz { ...SnkPriceDescriptorChangedFragment }
        listPriceWithTz { ...SnkPriceDescriptorFragment }

        # Dealer conditions
        listPriceDiscount { ...SnkPriceDescriptorChangedFragment }
        buyPriceSurcharge { ...SnkPriceDescriptorChangedFragment }
        profitMargin { ...SnkPriceDescriptorFragment }

        # Manufacturer conditions
        baseDiscount { ...SnkPriceDescriptorFragment }
        additionalDiscount { ...SnkPriceDescriptorChangedFragment }
        alternativeDiscount { ...SnkPriceDescriptorChangedFragment }
        positionDiscount { ...SnkPriceDescriptorChangedFragment }
      }
    }
  }
  ${SNK_PRICE_DESCRIPTOR_FRAGMENT}
  ${SNK_PRICE_DESCRIPTOR_CHANGED_FRAGMENT}
`;
